import { BrandLogo } from './BrandLogo'
import { BrandWord } from './BrandWord'
import { CarreirasNav } from './CarreirasNav'
import type { Candidato, CarreirasView } from '../types'

interface TopbarProps {
  view: CarreirasView
  routeType: string
  candidato: Candidato | null
  loggedIn: boolean
  logoInHeader: boolean
  onSair: () => void
  onNavEmpregos: () => void
  onNavSobre: () => void
  onNavMinhas: () => void
}

export function Topbar({
  view,
  routeType,
  candidato,
  loggedIn,
  logoInHeader,
  onSair,
  onNavEmpregos,
  onNavSobre,
  onNavMinhas,
}: TopbarProps) {
  return (
    <>
      <header
        className={`cr-topbar-float${logoInHeader ? ' is-visible' : ' is-hidden'}`}
        aria-hidden={!logoInHeader}
      >
        <div className="cr-wrap">
          <div className="cr-topbar liquid-glass cr-topbar-glass is-compact">
            <div className="cr-topbar-inner cr-nav-cluster">
              <a
                className="cr-brand"
                href="#/"
                aria-label="Grupo HI — início"
                tabIndex={logoInHeader ? 0 : -1}
                onClick={(e) => {
                  e.preventDefault()
                  onNavEmpregos()
                }}
              >
                <span className="cr-brand-logo-slot">
                  {logoInHeader ? <BrandLogo placement="header" /> : null}
                </span>
                {logoInHeader ? <BrandWord className="cr-brand-word is-visible" /> : null}
              </a>
              {logoInHeader ? (
                <CarreirasNav
                  view={view}
                  routeType={routeType}
                  candidato={candidato}
                  loggedIn={loggedIn}
                  onSair={onSair}
                  onNavEmpregos={onNavEmpregos}
                  onNavSobre={onNavSobre}
                  onNavMinhas={onNavMinhas}
                />
              ) : null}
            </div>
          </div>
        </div>
      </header>
      <div
        className={`cr-topbar-spacer${logoInHeader ? ' is-active' : ''}`}
        aria-hidden="true"
      />
    </>
  )
}
